// src/store/customGridRedux.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const customGridSlice = createSlice({
  name: "customGrid",
  initialState,
  reducers: {
    // 🔹 Filtro de texto simples
    setFilterText: (state, action) => {
      const { gridId, filterText } = action.payload;
      if (!state[gridId]) state[gridId] = {};
      state[gridId].filterText = filterText;
    },

    // 🔹 Coluna do filtro simples
    setFilterColumn: (state, action) => {
      const { gridId, filterColumn } = action.payload;
      if (!state[gridId]) state[gridId] = {};
      state[gridId].filterColumn = filterColumn;
    },

    // 🔹 Filtros compostos (array)
    setAllFilters: (state, action) => {
      const { gridId, filters } = action.payload;
      if (!state[gridId]) state[gridId] = {};
      state[gridId].allFilters = filters.map((f) => ({ ...f })); // cópia segura
    },

    // 🔹 Ordenação
    setSort: (state, action) => {
      const { gridId, sortField, sortDir } = action.payload;
      if (!state[gridId]) state[gridId] = {};
      state[gridId].sortField = sortField;
      state[gridId].sortDir = sortDir;
    },

    // 🔹 Paginação
    setPage: (state, action) => {
      const { gridId, page } = action.payload;
      if (!state[gridId]) state[gridId] = {};
      state[gridId].page = page;
    },

    // 🔹 (NOVO) Controle de visibilidade das colunas
    setVisibleColumns: (state, action) => {
      const { gridId, visibleColumns, knownColumns } = action.payload;
      if (!state[gridId]) state[gridId] = {};
      state[gridId].visibleColumns = Array.isArray(visibleColumns)
        ? visibleColumns
        : [];
      if (Array.isArray(knownColumns)) {
        state[gridId].knownColumns = knownColumns;
      }
    },

    // 🔹 Reset total de todos os grids
    resetGrid: (state) => {
      Object.keys(state).forEach((gridId) => {
        state[gridId] = {
          filterText: null,
          filterColumn: null,
          allFilters: null,
          sortField: null,
          sortDir: null,
          page: null,
          visibleColumns: null,
          knownColumns: null,
        };
      });
    },

    // 🔹 Reset de um grid específico por ID
    resetGridById: (state, action) => {
      const { gridId } = action.payload;
      if (state[gridId]) {
        state[gridId] = {
          filterText: null,
          filterColumn: null,
          allFilters: null,
          sortField: null,
          sortDir: null,
          page: null,
          visibleColumns: null,
          knownColumns: null,
        };
      }
    },
  },
});

export const {
  setFilterText,
  setFilterColumn,
  setAllFilters,
  setSort,
  setPage,
  setVisibleColumns,
  resetGrid,
  resetGridById,
} = customGridSlice.actions;

export default customGridSlice.reducer;
